import axios from 'axios'

const BASE_URL = process.env.REACT_APP_PATH
const ApiInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        "Sec-Fetch-Site": "none",
    }
});

// Read the token on every request, not once at import — otherwise a token refreshed
// after page load keeps sending the stale one and the API 403s "Invalid Token"
// until a hard refresh.
ApiInstance.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('serviceToken');
    return config;
});

export default ApiInstance;
